import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const OrderStatusStepperWrapper = styled(Box)`
  width: 100%;

  ${({ theme }) => css`
    ${theme.media.sm.down} {
      min-width: 720px;
    }
  `}
`;
